<template>
  <div>
    <home-banner />
    <div id="main-content">
      <expertise-area :items="areas" />
      <story />
      <team :items="team" />
      <download-app />
      <posts :posts="posts" />
      <contact />
      <newsletter />
      <modal :active.sync="modalAlertIsOpen">
        <div class="text-center">
          <h3>{{ alert.title }}</h3>
          <p>{{ alert.message }}</p>
        </div>
      </modal>
    </div>
  </div>
</template>


<script>
import DownloadApp from "@/components/Home/DownloadApp";
import ExpertiseArea from "@/components/Home/ExpertiseArea";
import HomeBanner from "@/components/Home/Banner";
import Posts from "@/components/Home/Posts";
import Story from "@/components/Home/Story";
import Team from "@/components/Home/Team";
import Newsletter from "@/components/Newsletter";
import Contact from "@/components/Home/Contact";
import Modal from "@/components/Modal";

import api from "../services/api";

export default {
  name: "Home",

  components: {
    Contact,
    DownloadApp,
    ExpertiseArea,
    HomeBanner,
    Newsletter,
    Team,
    Posts,
    Story,
    Modal,
  },

  data() {
    return {
      modalAlertIsOpen: false,
      alert: {},
      posts: [],
      areas: [],
      team: [],
    };
  },

  async created() {
    await this.getAreas();
    await this.getPosts();
    await this.getTeam();
    await this.getAlerts();
  },

  methods: {
    async getAreas() {
      const { data: areas } = await api.get("areas");
      this.areas = areas;
    },

    async getPosts() {
      const { data: posts } = await api.get("posts/home");
      this.posts = posts;
    },

    async getTeam() {
      const { data: team } = await api.get("team");
      this.team = team;
    },

    async getAlerts() {
      const { data: alert } = await api.get("alerts");
      if (alert) {
        this.alert.title = alert.title;
        this.alert.message = alert.message;
        this.modalAlertIsOpen = true;
      }
    },
  },
  beforeCreate() {
    document.documentElement.classList.add("has-scroll-smooth");
  },

  beforeDestroy() {
    document.documentElement.classList.remove("has-scroll-smooth");
  },
};
</script>
